module.exports = __webpack_public_path__ + "static/media/SE EXTC sem II 2025-26.39cde603.pdf";